<template>
  <v-container fluid>
    <div v-if="visibleData.length > 0">
      <v-row class="pa-2">
        <v-row>
          <v-skeleton-loader
            transition="fade-transition"
            height="94"
            type="list-item-avatar-three-line"
            v-for="(data,index) in visibleData"
            :key="index"
            :loading="show && data.visible"
            width="100%"
            style="min-width:100%"
          >
            <v-row>
              <v-col class="col-12" sm="12" md="12" style="padding: 0px 10px">
                <v-card elevation="2" width="100%" class="mt-2" v-if="data.visible" style="border-radius: 3px">
                  <v-row wrap>
                    <v-col class="col-4" sm="2" md="2">
                      <v-avatar size="calc(100vh*0.1)" color="primary" style="margin: 5px 0px 5px 20px; border-radius: 5px;">
                        <img v-if="'attendances' in data && data.attendances.image != null" :src="getImage(data.attendances.image,true)" style="border-radius: 5px;" alt="latest_punch_pic" @click="zoom(data.attendances.image)" />
                        <img v-else-if="typeof data.profilePicture != 'undefined'" :src="getImage(data.profilePicture, true)" @click="zoom(data.profilePicture)" style="border-radius: 5px;" alt="profile_pic"/>
                        <span
                          v-else
                          class="white--text headline"
                        >{{data.name.substring(0, 1).toUpperCase()}}</span>
                        
                      </v-avatar>
                    </v-col>

                    <v-col class="col-8" sm="10" md="10" style="margin-top: 13px; padding: 0px 15px">
                      
                      

                      <v-layout row wrap>
                        <v-flex xs7 sm7 md7> 
                          <h5 class="custom_h5" style="margin-top:2px">{{data.name}}</h5>
                        </v-flex>
                        <v-flex xs5 sm5 md5>
                          <div v-if="data.attendances">
                            <p style="margin-bottom: 1px !important; text-align: right; margin-right: 15px" class="custom_p">
                              <v-chip
                                v-if="data.attendances.punchType == 'IN'"
                                color="success"
                              >
                                {{data.attendances.punchType}}
                              </v-chip>
                              <v-chip
                                v-else
                                color="error"
                              >
                                {{data.attendances.punchType}}
                              </v-chip>
                            </p>
                          </div>

                          <div v-else>
                            <p class="custom_p" style="text-align: right; margin-right: 15px">
                              <v-chip                            
                                color="warning"
                                style="color: #1a1a1a"
                              >
                                Pending
                              </v-chip>
                            </p>
                          </div>
                          
                        </v-flex>
                      </v-layout>
                      <v-row wrap>
                        
                        <v-col class="col-12" sm="12" md="12" style="text-align: none !important; padding: 5px 10px">
                          <p
                            style="margin-bottom: 1px !important"
                            class="custom_p"
                            v-if="data.attendances"
                          >Last Seen: {{ data.attendances.time | moment('timezone', data.attendances.timezone.name,"Do MMM h:mm a z") }}</p>
                          <p
                          style="margin-bottom: 1px !important" 
                            class="custom_p"
                            v-else
                          >Last Seen: --- </p>
                          
                        </v-col>

                        <v-col class="col-12" sm="12" md="12" style="text-align: none !important; padding: 5px 10px">
                          <p style="margin-bottom: 3px !important" class="custom_p" v-if="data.attendances">Location: {{data.attendances.originalLocation.name}}</p>
                          <p style="margin-bottom: 3px !important" class="custom_p" v-else>Location: ---</p>
                        </v-col>
                      
                        
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-skeleton-loader>
        </v-row>
      </v-row>

      <!-- pagination -->
      <v-row v-if="renderedData.length > 0">
        <v-col class="col-12" sm="8" md="8">
          <v-row wrap>

            <v-col class="col-8" sm="4" md="4">
              <v-select
                label="Records per page"
                v-model="records"
                :items="rowsPerPage"
                dense
                outlined
              ></v-select>
            </v-col>

            <v-col class="col-2" sm="2" md="2" align="right">
              <v-btn
                :disabled="currentPage != 0 ? false : true"
                text
                fab
                small
                color="primary"
                style="margin-left: 11px"
                @click="prev"
              >
                <v-icon>navigate_before</v-icon>
              </v-btn>
            </v-col>

            <v-col class="col-2" sm="2" md="2">
              <v-btn text fab small color="primary" :disabled="currentPage == totalPages-1 ? true : false" @click="next">
                <v-icon>navigate_next</v-icon>
              </v-btn>
            </v-col>

          </v-row>
        </v-col>
      </v-row>
    </div>

    <div v-else style="text-align: center">
      <v-card style="padding: 10px" flat>
        <v-card-text>
            <v-img
              :src="noSearchResultImage"
              class="mb-3"
              contain
              height="300"
            ></v-img>
            <h4 style="font-size: 17px; opacity: 0.7; font-weight: 500">
              Sorry, no records found
            </h4>
        </v-card-text>
      </v-card>
    </div>

  </v-container>
</template>

<script>
export default {
  props: {
    renderedData: {
      type: Array
    },
    show: {
      type: Boolean
    }
  },
  data() {
    return {
     rowsPerPage: ["4", "8", "16", "All"],
      records: "4",
      currentPage: 0,
      totalPages: ""
    };
  },
  computed: {
    noSearchResultImage() {
      return require('@/assets/noSearchResult.png')
    },
    visibleData() {
      var records = Number(this.records);
      var filterData = _.filter(this.renderedData, data => {
        return data.visible == true;
      });
      this.renderedData = filterData;
      this.totalPages = Math.ceil( this.renderedData.length / records);
      if (this.records.toString() == "All") {
        return this.renderedData;
      } else {
        return this.renderedData.slice(
          this.currentPage * records,
          this.currentPage * records + records
        )
      }

    
    }
  },
  methods: {

    zoom(url){
      console.log(url)
      this.$emit('zoom', url)
    },
     getImage(src,small) {
      if (src == undefined) {
        const demoImg = require("@/assets/demo.png");
        return demoImg;
      }


      if(small) {

        src = src.insert(src.lastIndexOf("."),"_200x200")
        
      }

      return this.$store.state.imagePath + src;
    },
    // getProfilePic(user) {
    //   console.log("User recived in the get iMgae", user)
    //   if("attendances" in user){
        
    //     if(user.attendances.image != null) {
    //       console.log("user image got", user.attendances.image)
    //       var src = this.$store.state.imagePath + user.attendances.image
    //       console.log("src",src)
    //       return src
    //     }
    //   } else if (typeof user.profilePicture != "undefined") {
        
    //     return this.$store.state.attachmentPath + user.profilePicture;
    //   }
    // },

    // numPages() {
    //   return Math.ceil(this.renderedData.length / this.records);
    // },

    updateRecords(page) {
      this.currentPage = page;
    },

    next() {
      this.currentPage++;
    },

    prev() {
      this.currentPage--;
    }
  }
};
</script>

<style scoped>
.v-chip {
  font-size: 12px !important;
  padding: 2px 10px;
}
.custom_heading {
  font-size: 18px;
  letter-spacing: 0.5px;
}
.main_card {
  border-radius: 5px !important;
}
.timeline_img {
  width: 80px;
  height: 80px;
  image-orientation: center;
  margin: 6px 15px;
}
.custom_h5 {
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.5px;
  margin: 0px;
  text-align: left;
}
.custom_p {
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0.5px;
  margin: 1px;
  text-align: left;
}
</style>
